var option_default = {
  "option": "lI2Hh",
  "user_choice": "l-F1A",
  "check": "EHuD5",
  "image": "rrD3-",
  "input": "_8gXTz",
  "title": "ibJKp",
  "centered": "DDqS4",
  "with_result": "puMrv",
  "list": "YkJPk",
  "with_image": "JCB5i",
  "progress": "P4XaH",
  "progress_value": "_8NR1F",
  "label": "-VjBp",
  "cta": "Arvzr",
  "adornment_icon": "PulSl",
  "remove": "YZzEE",
  "removeButton": "ALTUP",
  "removeButtonIcon": "_8r4vE",
  "overlay": "_2-mfe",
  "shown": "Nx8lC",
  "dark": "YxBai",
  "spinner": "eIjm4",
  "spin": "Ct05Z"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
